import {MDB_TYPES } from "@meddbriefer/scenario-data/constants.js"

import SimpleCheckListItem from "./SimpleCheckListItem"
import CheckListItemWithOptions from "./CheckListItemWithOptions"
import NestedChecklist from "./NestedChecklist"

const CheckListItem = ({ctx, n, of, asTable=false}) => {

    switch(ctx.type) {
        case MDB_TYPES.ASSESS:
        case MDB_TYPES.REQUIRED:
            return <SimpleCheckListItem 
                        ctx={ctx} 
                        asTable={asTable}
                    />
        case MDB_TYPES.CL_PROMPT:
            return <SimpleCheckListItem 
                        ctx={ctx} 
                        hasAbbrLabel={false} 
                        hasGraded={false}
                        hasFeedback={false}
                        asTable={asTable}
                    />
        case MDB_TYPES.NESTED_CHECKLIST:
            return <NestedChecklist 
                        ctx={ctx} 
                        asTable={asTable} 
                    />
        case MDB_TYPES.DECISION:
            return <CheckListItemWithOptions 
                        ctx={ctx} 
                        childType={MDB_TYPES.DECISION_OPTION} 
                        asTable={asTable}
                    />
        case MDB_TYPES.AWO:
            return <CheckListItemWithOptions 
                        ctx={ctx} 
                        childType={MDB_TYPES.ASSESS_OPTION} 
                        asTable={asTable}
                    />
        default:
            return (
                <pre>
                    {JSON.stringify(ctx)}
                </pre>
            )
    }

}

export default CheckListItem